import { getAuthToken } from '@feat-auth/auth.config';
import type { AxiosRequestConfig } from 'axios';

export const securityWorker = async (): Promise<AxiosRequestConfig> => {
  const token = await getAuthToken();
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};
